import React from 'react';
import email from '../../components/email.json';
import pixImg from '../../images/pix.gif';
import classNames from 'classnames';

export default class OptoutConfirmationTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: this.props.detail
    };
  }

  render() {
    return (
      <main>
        <div id='optinMiddle'>
          <div className={classNames('centerWrap', 'OptinConfirmBar')}>
            <div className='OptinConfirmContent'>
              <p className='OptinConfirmContent'>
                <img
                  src={pixImg}
                  alt={
                    email.optout.confirmation.ui.body.confirmationBar.descriptive.eng
                  }
                />
                <strong>
                  {email.optout.confirmation.ui.body.confirmationBar.eng}
                </strong>
              </p>
            </div>
          </div>
          <div className={classNames('content', 'centerWrap')}>
            <p>{email.optin.body.display.french.message.eng}</p>
            <br />
            <h1>{email.optout.confirmation.ui.body.voltage.eng}</h1>
            <h2>
              <strong>
                {email.optout.confirmation.ui.body.section1.header.eng}
              </strong>
            </h2>
            <hr />
            <p>
              {' '}
              {email.optout.confirmation.ui.body.section1.text1.eng}
            </p>
            <p>
              {email.optout.confirmation.ui.body.section1.text2.eng}
              <i>
                {email.optout.confirmation.ui.body.section1.text2.italics.eng}
              </i>
            </p>
            <p>
              {email.optout.confirmation.ui.body.section1.text3.eng}
              <a
                href={
                  'mailto:' +
                  email.optout.confirmation.ui.body.section1.supportemail.eng
                }
              >
                <u>
                  {email.optout.confirmation.ui.body.section1.supportemail.eng}
                </u>
              </a>
              {email.optout.confirmation.ui.body.section1.splitterText.eng}
              {email.optout.confirmation.ui.body.section1.phone.eng}
            </p>
            <h2 className='changePref'>
              {email.optout.confirmation.ui.body.section2.header.eng}
            </h2>
            <hr />
            <p>
              {email.optout.confirmation.ui.body.section.text1.eng}
              <a href={this.state.detail}>
                {email.optout.confirmation.ui.body.section.link.text.eng}
              </a>
              {email.optout.confirmation.ui.body.section.link.period.eng}
            </p>
            <br /><br /><br />
            <h1>{email.optout.confirmation.ui.body.voltage.fr}</h1>
            <h2>
              <strong>
                {email.optout.confirmation.ui.body.section1.header.fr}
              </strong>
            </h2>
            <hr />
            <p>
              {' ' + email.optout.confirmation.ui.body.section1.text1.fr}
            </p>
            <p>
              {email.optout.confirmation.ui.body.section1.text2.fr}
              <i>
                {email.optout.confirmation.ui.body.section1.text2.italics.fr}
              </i>
              {email.optout.confirmation.ui.body.section1.text2.end.fr}
            </p>
            <p>
              {email.optout.confirmation.ui.body.section1.text3.fr}
              <a
                href={
                  'mailto:' +
                  email.optout.confirmation.ui.body.section1.supportemail.eng
                }
              >
                <u>{email.optout.confirmation.ui.body.section1.supportemail.eng}</u>
              </a>
              {email.optout.confirmation.ui.body.section1.splitterText.fr}
              {email.optout.confirmation.ui.body.section1.phone.eng}
            </p>
            <h2 className='changePref'>{email.optout.confirmation.ui.body.section2.header.fr}</h2>
            <hr />
            <p>
              {email.optout.confirmation.ui.body.section.text1.fr}
              <a href={this.state.detail}>
                {email.optout.confirmation.ui.body.section.link.text.fr}
              </a>
              {email.optout.confirmation.ui.body.section.link.period.eng}
            </p>
          </div>
        </div>
      </main>
    );
  }
}
